import React from 'react'
// import { PAGE_ROUTE, PAGE_MENU } from '../../constants';
// import { Link } from 'react-router-dom'
import './menu.css'

const Menu = () => (
  <nav className="app-menu">
    <ul className="app-menu__list">
      {/* <li className="app-menu__item"><Link className="app-menu__link" to={PAGE_ROUTE.HOME}>{PAGE_MENU.HOME}</Link></li> */}
      {/* <li className="app-menu__item"><Link className="app-menu__link" to={PAGE_ROUTE.SIGNIN}>{PAGE_MENU.SIGNIN}</Link></li> */}
      {/* <li className="app-menu__item"><Link className="app-menu__link" to={PAGE_ROUTE.CONTACT}>{PAGE_MENU.CONTACT}</Link></li> */}
      {/* <li className="app-menu__item"><Link className="app-menu__link" to={PAGE_ROUTE.ABOUT}>{PAGE_MENU.ABOUT}</Link></li> */}
    </ul>
  </nav>
)

export default Menu;
